export enum ContentLike {
  AI_PLAYGROUND_CARD = 'AI_PLAYGROUND_CARD',
}
